import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { useAppDispatch } from "../../../App/hooks";
import { Additional } from "./Additional";
import { store } from "../../../App/store";
import {
  ICCOrderAddOrderFormValues,
  ICCOrderSearchParams,
  ICCOrderTableReport,
} from "src/Interfaces/ccOrder";
import { setCCOrderOrderFormValues } from "src/Features/CCOrder/ccOrderSlice";
import { getCCOrderTradeTable } from "src/Requests/ccOrder";

interface IProps {
  searchParam: ICCOrderSearchParams;
}

const CCTradeTable = ({ searchParam }: IProps) => {
  const dispatch = useAppDispatch();

  const tableRowClickHandler = (row: ICCOrderTableReport) => {
    dispatch(
      setCCOrderOrderFormValues({
        ...(store.getState().ccOrder?.addOrderFormValues ||
          ({} as ICCOrderAddOrderFormValues)),
        coveredCallOrderBuyLegs: row?.coveredCallOrderBuyLegs,
        coveredCallOrderSellLeg: row?.coveredCallOrderSellLeg,
        coveredCallOrderType: row?.coveredCallOrderType,
        coveredCallPositionStrategyEnum: row?.coveredCallPositionStrategyEnum,
      }),
    );
  };

  return (
    <div className="flex flex-col gap-3 justify-start items-end w-full trade-table relative">
      <TableTemplate<ICCOrderSearchParams, ICCOrderTableReport>
        refreshTableTime={5000}
        withSort
        getDataTable={getCCOrderTradeTable}
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            onTableRowClick={tableRowClickHandler}
            sortingType={sortingType}
            setSortingType={setSortingType}
            AdditionalBody={Additional}
            tableBoxClassName="max-h-[500px] overflow-auto"
          />
        )}
        searchParameters={searchParam}
        showPageSize
      />
    </div>
  );
};

export default CCTradeTable;
